import { gql } from "@apollo/client";

const CREATE_ORG_RECOMMEND = gql`
  mutation CreateOrgRecommend(
    $entityArgs: CombinedCreateEntityInput!
    $scheduleArgs: CreateScheduleInput
    $transactionArgs: CombinedCreateTransactionInput
    $recOrgEmailArgs: RecOrgEmailArgs!
  ) {
    createOrgRecommend(
      entityArgs: $entityArgs
      scheduleArgs: $scheduleArgs
      transactionArgs: $transactionArgs
      recOrgEmailArgs: $recOrgEmailArgs
    ) {
      ... on OrganizationEntity {
        _id
      }
    }
  }
`;

const CREATE_ENTITY = gql`
  mutation CreateEntity($args: CombinedCreateEntityInput) {
    createEntity(args: $args) {
      ... on FirmEntity {
        _id
      }
      ... on BranchEntity {
        _id
      }
      ... on OrganizationEntity {
        _id
      }
    }
  }
`;

const FULL_DELETE_ENTITY = gql`
  mutation FullDeleteEntity($args: CombinedUpdateEntityInput) {
    fullDeleteEntity(args: $args) {
      ... on OrganizationEntity {
        _id
      }
      ... on CustodianEntity {
        _id
      }
      ... on FirmEntity {
        _id
      }
      ... on PartnerEntity {
        _id
      }
      ... on BranchEntity {
        _id
      }
    }
  }
`;

const UPDATE_ENTITY = gql`
  mutation UpdateEntity($entityId: ID!, $args: CombinedUpdateEntityInput) {
    updateEntity(entityId: $entityId, args: $args) {
      ... on OrganizationEntity {
        _id
      }
      ... on FirmEntity {
        _id
      }
      ... on BranchEntity {
        _id
      }
    }
  }
`;

const APPROVE_ORGANIZATION = gql`
  mutation ApproveOrganization($entityId: ID!) {
    approveOrganization(entityId: $entityId) {
      ... on OrganizationEntity {
        _id
      }
    }
  }
`;

const DECLINE_ORGANIZATION = gql`
  mutation DeclineOrganization($entityId: ID!) {
    declineOrganization(entityId: $entityId) {
      ... on OrganizationEntity {
        _id
      }
    }
  }
`;

export {
  CREATE_ENTITY,
  CREATE_ORG_RECOMMEND,
  FULL_DELETE_ENTITY,
  UPDATE_ENTITY,
  APPROVE_ORGANIZATION,
  DECLINE_ORGANIZATION,
};
